import { isAndroid } from './utils/index';
import { setupWebViewJavascriptBridge } from './bridge/index';

/**
 * 初始化
 */
setupWebViewJavascriptBridge((bridge: any) => {
  if (isAndroid()) {
    bridge.init((message: any, responseCallback: any) => {
      console.log('Bridge init msg:', message);
      const data = { 'Javascript Responds': '测试中文!' };
      if (responseCallback) {
        responseCallback(data);
      }
    });
  }
});

export * from './bridge/callHandler';
export * from './bridge/registerHandler';
export * from './utils/index';
